module.exports = __webpack_public_path__ + "img/clever-together-blue.55a7a860.png";